<template>
  <validation-provider
    :rules="rules"
    :name="name"
    :vid="vid"
    ref="validator"
    v-slot="{ valid, errors }"
  >
    <div class="content" :class="{ error: errors.length > 0 }">
      <prism-editor
        class="source-editor"
        v-model="currentValue"
        v-bind="$attrs"
      />
      <p class="error-message" v-if="errors.length > 0">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import PrismEditor from "vue-prism-editor";

export default {
  name: "control-code-editor",

  components: {
    PrismEditor
  },

  data() {
    return {
      currentValue: ""
    };
  },

  props: {
    value: String,

    vid: String,
    name: String,
    rules: [Object, String]
  },

  mounted() {
    this.currentValue = this.value;
  },

  methods: {
    setErrors(errors) {
      this.$refs.validator.setErrors(errors);
    }
  },

  watch: {
    value(val) {
      this.currentValue = val;
    },

    currentValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 1rem;

  &.error {
    .source-editor {
      margin-bottom: 0;
      overflow-x: auto;

      &::v-deep pre {
        margin-bottom: 0;
        border: solid 1px $danger;
        border-radius: $radius;
        box-shadow: none;
      }
    }

    .error-message {
      margin: 0;
      margin-top: 0.25rem;
      color: $red;
      font-size: 0.75rem;
      font-family: $family-sans-serif;
    }
  }
}
</style>
